import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import RevolutionizeImg from "../../images/location_new/fold7/San-Diego.webp";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

function Revolutionize(props) {
  return (
    <div className="revolutionize_section">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>Why Choose TekRevol for Mobile App Development in San Diego</h2>
            <p>
              TekRevol offers the best mobile app development in San Diego,
              where the fusion of innovation and local expertise results in
              customized solutions designed to ensure your success.{" "}
            </p>
            <p>
              Our track record showcases a history of delivering top-notch
              mobile apps, earning recognition and success within the industry.
              We consistently lead in mobile technology trends, utilizing the
              latest tools and frameworks to develop innovative and future-proof
              apps.{" "}
            </p>
            <p>
              Moreover, we offer cost-effective solutions without compromising
              on quality, making mobile app development accessible to businesses
              of all sizes.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="revolutionize_img"
          >
            <LazyLoadImage
              src={RevolutionizeImg}
              effect="blur"
              alt="Image"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Revolutionize;
